<template>
  <e-chart :options="options" autoresize class="tw-w-full" />
</template>

<script>
export default {
  name: 'TheTabSummaryTemperature',
  props: {
    records: {
      type: Array
    }
  },
  computed: {
    chartData () {
      if (this.records.length > 0) {
        const output = this.records.slice(this.records.length - 24 - 1).map((item) => {
          return [item.TmStamp.date, this._.round((((item.AirTC_Avg) * 1.8) + 32)), this._.round(item.Rain_mm_Tot, 1)]
        })
        output.unshift(['time', 'Temperature', 'Precipitation'])
        return output
      } else {
        return []
      }
    },
    options () {
      return {
        title: [
          {
            text: 'Air Temperature and Precipitation'
          }
        ],
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.chartData
        },
        grid: [{
          left: 50,
          right: 50,
          height: '30%'
        }, {
          left: 50,
          right: 50,
          top: '60%',
          height: '30%'
        }],
        yAxis: [
          {
            type: 'value',
            name: 'Air Temp. (°F)',
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            gridIndex: 1,
            type: 'value',
            name: 'Precip. (mm)',
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        xAxis: [
          {
            type: 'time'
          },
          {
            gridIndex: 1,
            type: 'time'
          }
        ],
        series: [
          {
            name: 'Temperature',
            type: 'line',
            encode: {
              y: 1
            },
            markPoint: {
              data: [
                { type: 'max', name: 'Max' },
                { type: 'min', name: 'Min' }
              ]
            },
            markLine: {
              data: [
                { type: 'average', name: 'Average' }
              ],
              precision: 0
            }
          },
          {
            name: 'Precipitation',
            type: 'bar',
            xAxisIndex: 1,
            yAxisIndex: 1,
            symbolSize: 8,
            encode: {
              y: 2
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
